import React from 'react';
import {Box, Skeleton, Typography} from "@mui/material";
import {DataForPreviewDto} from "../../../editor/spots/rightContent/flyerPages/FramesScreenRightPanel";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    previewContentWrapper: {
        display: `flex`,
        flex: `1 1 auto`,
        flexFlow: `column`,
        justifyContent: `space-between`,
        padding: `10px 15px`,
        "& > .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: `inherit`,
        },
    }
}))
interface Props {
    previewUrlData: DataForPreviewDto
}
export const LinkPreviewPopup: React.FC<Props> = ({
                                                      previewUrlData
                                                  }) => {
    const classes = useStyles();
    return (
        <Box sx={{
            display: `flex`,
            width: "100%",
            maxHeight: "100%",
            flexFlow: `column`,
        }}>
            {
                previewUrlData?.image
                    ?
                    <Box
                        sx={{
                            display: `flex`,
                            flex: `0 0 40%`,
                            height: `100%`,
                            background: `url(${previewUrlData?.image}) center center / contain no-repeat rgb(225, 232, 237)`,
                        }}
                    >
                    </Box>
                    :
                    <Skeleton
                        animation="wave"
                        variant="rectangular"
                        sx={{
                            display: `flex`,
                            flex: `0 0 40%`,
                            height: `100%`,
                        }}
                    />
            }
            <Box
                className={classes.previewContentWrapper}
            >
                {
                    previewUrlData?.image
                        ?
                        <>
                            <Typography
                                fontWeight={700}
                                sx={{
                                    display: "-webkit-box",
                                    "WebkitLineClamp": 2,
                                    "WebkitBoxOrient": "vertical"
                                }}
                            >
                                {previewUrlData?.title}
                            </Typography>
                            <Typography
                                fontSize={`14px`}
                                sx={{
                                    // flex: "1 1 auto",
                                    display: "-webkit-box",
                                    "WebkitLineClamp": 4,
                                    "WebkitBoxOrient": "vertical"
                                }}
                            >
                                {previewUrlData?.description}
                            </Typography>
                            <Typography
                                sx={{
                                    display: "-webkit-box",
                                    "WebkitLineClamp": 1,
                                    "WebkitBoxOrient": "vertical"
                                }}
                                fontSize={`12px`}
                            >
                                {previewUrlData?.domain}
                            </Typography>
                        </>
                        :
                        <>
                            <Skeleton animation="wave"/>
                            <Skeleton animation="wave"/>
                            <Skeleton animation="wave"/>
                        </>
                }
            </Box>
        </Box>
    )
}